import type { SlideMetadata } from "@/services/api.service";

export const isScratchpadEnabled = (
  metadata: SlideMetadata | Record<string, unknown> | null | undefined,
): boolean => metadata?.scratchpad?.enabled === true;

export const buildScratchpadMetadataPatch = (
  enabled: boolean,
): Pick<SlideMetadata, "scratchpad"> => ({
  scratchpad: { enabled },
});
